import React from "react";
import "../App.css";

const ListaUtiles = () => {
  const listas = [
    {
      titulo: "",
      imagen: "/imagenes/listasutiles/pre-kinder.jpg",
      pdf: "/pdfs/LISTA  PKINDER 2026.pdf",
    },
    {
      titulo: "",
      imagen: "/imagenes/listasutiles/kinder.jpg",
      pdf: "/pdfs/LISTA KÍNDER 2026.pdf",
    },
    {
      titulo: "",
      imagen: "/imagenes/listasutiles/1basico.jpg",
      pdf: "/pdfs/LISTA 1 2026.pdf",
    },
    {
      titulo: "",
      imagen: "/imagenes/listasutiles/2basico.jpg",
      pdf: "/pdfs/LISTA 2 2026.pdf",
    },
    {
      titulo: "",
      imagen: "/imagenes/listasutiles/3y4basico.jpg",
      pdf: "/pdfs/LISTA 3y4 2026.pdf",
    },
    {
      titulo: "",
      imagen: "/imagenes/listasutiles/5a8basico.jpg",
      pdf: "/pdfs/LISTA 5y8 2026.pdf",
    },
  ];

  return (
    <div id="listacursos" className="cursos-container">
      <h2 className="junaeb-title">
        Lista de Útiles Escolares 2026
      </h2>

      <div className="cards-grid">
        {listas.map((lista, index) => (
          <a
            key={index}
            href={lista.pdf}
            target="_blank"
            rel="noopener noreferrer"
            className="card-link"
          >
            <div className="pdf-card">
              <img
                src={lista.imagen}
                alt={lista.titulo}
                className="pdf-image"
              />

              <div className="pdf-title">
                {lista.titulo}
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ListaUtiles;
